import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
var __jsx = React.createElement;
import { selectUsersession } from "redux/reducers/userSessionReducer";
import { useSelector } from "react-redux";
import styles from "./CustomerLogo.module.scss";
function CustomerLogo(props) {
  var _useSelector = useSelector(selectUsersession),
    userSessionData = _useSelector.data,
    userSessionStatus = _useSelector.status;
  if (!userSessionData || userSessionStatus !== "done") return undefined;
  var accountId = userSessionData.user.account.accountId;
  var CUSTOMIZED_INSTITUTIONAL_LOGO = userSessionData.enabledFences.CUSTOMIZED_INSTITUTIONAL_LOGO;
  if (!(CUSTOMIZED_INSTITUTIONAL_LOGO && CUSTOMIZED_INSTITUTIONAL_LOGO === 1)) return undefined;
  function isTurkishAccountId() {
    if (accountId === "38618" || accountId === "264741" || accountId === "40919" || accountId === "263675" || accountId === "263884" || accountId === "263661" || accountId === "31788" || accountId === "50262" || accountId === "41578" || accountId === "264758" || accountId === "52534" || accountId === "49428" || accountId === "40859" || accountId === "264470" || accountId === "264517" || accountId === "38658" || accountId === "67394") {
      return true;
    }
    return false;
  }
  var customerUrl = "";
  if (isTurkishAccountId()) {
    customerUrl = "http://www.ulakbim.gov.tr/cabim/ekual/";
  } else {
    customerUrl = "/home.url";
  }
  // TODO: Get path from enabled fences when it is added
  var customerImagePath = "/ev-customer-images/current/".concat(accountId, ".gif");
  return /*#__PURE__*/React.createElement("a", _extends({}, props, {
    href: "".concat(customerUrl),
    title: "".concat(customerUrl)
  }), /*#__PURE__*/React.createElement("img", {
    id: "custom-logo-img",
    alt: "Customer Logo",
    src: "".concat(customerImagePath),
    border: "0",
    className: "".concat(styles.logo_ribbon)
  }));
}
export default CustomerLogo;